<rkt-table
  [rows]="financialAccounts"
  [columns]="columns"
  [limit]="10"
  [count]="totalElements"
  (fetchData)="getFinancialAccounts($event)"
  [loadingIndicator]="loading"
  [offset]="activePage"
  [messages]="{ emptyMessage: emptyListMessage }"
  emptyValuePlaceholder="--"
  (rowActivated)="onRowClick($event)"
></rkt-table>
